import { StyledBackLink } from './component.styles.js'

export default StyledBackLink
